import CartItem from '../domain/entities/Cart/CartItem';

export default class CartItemUtils {
  static groupCartItemsByField(data: CartItem[], field: keyof CartItem, defaultValue: string): Map<string, CartItem[]> {
    return data.reduce((acc: Map<string, CartItem[]>, current: CartItem) => {
      const key = (current[field] || defaultValue) as string;
      return acc.set(key, [...acc.get(key) || [], current]);
    }, new Map<string, CartItem[]>());
  }
}
